import { Button, ModalProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Modal } from '@shared/ui';

type DeleteModalProps = {
  open: boolean;
  loading?: boolean;
  disabled?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number | false;
  title?: string;
  onClose: () => void;
  onDelete?: () => Promise<void> | void;
} & ModalProps;

export default function DeleteModal({
  open,
  loading,
  disabled,
  maxWidth = 'xs',
  title,
  onClose,
  onDelete,
  ...props
}: DeleteModalProps) {
  const { t: tGlobal } = useTranslation('dashboard', { keyPrefix: 'global' });

  const defaultTitle = tGlobal('delete_item');

  const handleDelete = async () => {
    await onDelete?.();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} maxWidth={maxWidth} data-testid='delete-modal' {...props}>
      <Modal.Header titleProps={{ color: 'error.dark' }} title={title || defaultTitle} />
      <Modal.Body>
        <Typography fontWeight={500} variant='body1'>
          {props.children}
        </Typography>
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-testid='delete-modal-cancel-btn'
          variant='contained'
          color='gray'
          onClick={onClose}
        >
          {tGlobal('cancel')}
        </Button>
        <Button
          data-testid='delete-modal-confirm-btn'
          loading={loading}
          disabled={disabled}
          variant='contained'
          color='error'
          onClick={() => void handleDelete()}
        >
          {tGlobal('delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
